<template>
    <div class="container header-container">
        <div class="row header" :class="{'background-disabled': !enableBackgroundForSmallerScreens}">
            <div class="logo" :class="{'reversed': reversedColors}">
                EntropySpot
            </div>
            <button class="btn"
                    @click="close()"
                    v-if="isCloseButtonVisible">
                <img src="@/assets/icons/close.svg" alt="Close">
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Header',
        props: {
            isCloseButtonVisible: Boolean,
            reversedColors: Boolean,
            enableBackgroundForSmallerScreens: Boolean
        },
        methods: {
            close() {
                this.$emit('close')
            }
        }
    }
</script>

<style scoped lang="scss">
    @import './src/assets/styles/variables/variables';

    .header-container {
        width: 90%;
        margin: auto;
        left: 0;
        right: 0;
        position: fixed;
        z-index: 900;

        .header {
            position: relative;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            height: $header-height-full;
            max-height: 110px;
            min-height: 80px;

            button {
                background: transparent;
            }

            .logo {
                z-index: 900;
                position: relative;
                font-size: 1.4em;

                &.reversed {
                    color: $primary;
                }
            }
        }
    }

    @media all and (max-width: 1150px) {
        .header {
            height: $header-height-mobile !important;
            background: $primary;

            &.background-disabled {
                background: rgba(white, .95);
            }
        }
    }
</style>
